import { cva, type VariantProps } from 'class-variance-authority'
import { Loader2 } from 'lucide-react'
import type { FC } from 'react'

import { cn } from '../lib/cn'

const loaderVariants = cva('animate-spin', {
  variants: {
    size: {
      sm: 'size-4',
      md: 'size-6',
      lg: 'size-8 ',
      xl: 'size-10 ',
      block: 'size-8 flex w-full text-muted-foreground my-8 ',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
})

export interface SpinProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof loaderVariants> {
  className?: string
  strokeWidth?: number
}
export const Spin: FC<SpinProps> = ({ className, size, strokeWidth = 1.5 }) => (
  <Loader2 className={cn(loaderVariants({ size }), className)} strokeWidth={strokeWidth} />
)
